export async function chamar<T>(rota: string, dados?: unknown, metodo?: string): Promise<T> {
  const r = await fetch(rota, {
    credentials: 'same-origin',
    method: metodo ?? (dados === undefined ? 'GET' : 'POST'),
    headers: { 'Content-Type': 'application/json' },
    ...(dados === undefined ? {} : { body: JSON.stringify(dados) }),
  });
  const resposta = await r.json();
  if (!r.ok)
    throw new Error(resposta.code ?? 'erro');
  return resposta as T;
}

export const gestao = <T>(
  acao: string,
  dados?: unknown
) => chamar<T>(
  `/api/v1/integracoes/gestao/${acao}`,
  dados,
);
